import type { SelfServiceAPI } from 'types';
import type { Options } from '../types';
import api from 'lib/axios/api';
import handleServiceError from '../utils/handleServiceError';

interface Params {
  bookingId: string;
  cancellationId: string;
}

const getCancellation = async (
  { bookingId, cancellationId }: Params,
  options: Options = {},
): Promise<SelfServiceAPI.GetCancellation.Response> => {
  try {
    const { data } = await api.get(`/bookings/${bookingId}/cancellations/${cancellationId}`);
    return data;
  } catch (error) {
    handleServiceError(error, {
      operationName: `GET /bookings/${bookingId}/cancellations/${cancellationId}`,
      skipUnauthenticatedRedirection: options.skipUnauthenticatedRedirection,
    });

    return new Promise(() => {});
  }
};

export default getCancellation;
